import DraggableItem from './component'

export default DraggableItem
